import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withStyles, Tooltip, Chip } from '@material-ui/core';
import { Link as MiddleIcon } from '@material-ui/icons';
import { Logger } from 'data/common';

class MiddleStatus extends PureComponent {
    static propTypes = {
        middleState: PropTypes.string.isRequired,
        middleName: PropTypes.string,
        theme: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired
    };
    static defaultProps = {
        middleName: null
    };

    render() {
        const { middleState, middleName, theme, classes } = this.props;
        let iconStyle = {};
        switch (middleState) {
            case 'connected':
                iconStyle = { color: theme.palette.success.main };
                break;
            case 'disconnected':
                iconStyle = { color: theme.palette.error.main };
                break;
            case 'pending':
                iconStyle = { color: theme.palette.colors.orange500 };
                break;
            default:
                Logger.error(`L'état "${middleState}" du middleware n'est pas pris en charge`);
                return null;
        }
        return (
            <Tooltip placement="top-start" title={Translator.translate(`general.middleStatus.${middleState}`)}>
                {middleName ? (
                    <div className={classes.container}>
                        <Chip
                            classes={{ root: classes.rootChip }}
                            label={middleName}
                            icon={<MiddleIcon style={iconStyle} className={classes.middleIcon} />}
                            variant="outlined"
                        />
                    </div>
                ) : (
                    <MiddleIcon style={iconStyle} className={classes.middleIcon} />
                )}
            </Tooltip>
        );
    }
}

const styles = () => ({
    container: {
        display: 'flex',
        margin: 8
    },
    rootChip: {
        flexDirection: 'row-reverse',
        justifyContent: 'space-between',
        width: 90
    },
    middleIcon: {
        backgroundColor: 'white',
        '-webkit-border-radius': '50%',
        '-moz-border-radius': '50%',
        borderRadius: '50%',
        margin: '0 3px'
    }
});

export default withStyles(styles, { withTheme: true })(MiddleStatus);



// WEBPACK FOOTER //
// ./data/components/MiddleStatus.js